import { CustomerNote } from "../customer_note/CustomerNote"

export class CustomerOrderPartDetails {
  displayOrder: number
  name: string
  notes: CustomerNote[]
  price: number
  status: number

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(displayOrder: number, name: string, notesJson: any, price: number, status: number) {
    this.displayOrder = displayOrder
    this.name = name
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notesJson ? notesJson.map((n: any) => new CustomerNote(n.content)) : []
    this.price = price
    this.status = status
  }
}